/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_TitleInputs */

const en_ui_pace_est_title = /** @type {(inputs: Ui_Pace_Est_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate Threshold Pace`)
};

const de_ui_pace_est_title = /** @type {(inputs: Ui_Pace_Est_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo schätzen`)
};

/**
* | output |
* | --- |
* | "Estimate Threshold Pace" |
*
* @param {Ui_Pace_Est_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_title = /** @type {((inputs?: Ui_Pace_Est_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_title(inputs)
	return de_ui_pace_est_title(inputs)
});